import React from "react";

import DromoUploader from "dromo-uploader-react";

const DromoUploaderDropBox = (props) => {
  const { fields, importIdentifier, resultsHandler, dropboxInnerContent } =
    props;

  const settings = {
    importIdentifier: `${importIdentifier}`,
    allowInvalidSubmit: false,
    manualInputDisabled: true,
    manualInputOnly: false,
    displayEncoding: false,
    backendSync: true,
    allowCustomFields: false,
    maxRecords: null,
    developmentMode: false,
    backendOverride: {
      url: process.env.REACT_APP_DROMO_BACKENDOVERRIDE_URL,
      type: "AWS",
    },
  };

  const user = {
    id: "1",
    name: "myDigitalOffice",
    email: "admin@mydigitaloffice.ca",
    companyId: "myDigitalOffice",
    companyName: "myDigitalOffice",
  };

  return (
    <DromoUploader
      licenseKey={process.env.REACT_APP_DROMO_FRONTEND_LICENSEKEY}
      style={{
        border: "0.5px dashed #CAD3DA",
        background: "white",
        marginBottom: "20px",
      }}
      settings={settings}
      fields={fields}
      user={user}
      onResults={(data) => resultsHandler(data)}
    >
      {dropboxInnerContent}
    </DromoUploader>
  );
};

export default DromoUploaderDropBox;
